import { useSelector } from "react-redux";
import * as nodeUtils from "../controller/utils/nodeUtils";
import { getRoot } from "../redux/slice/structureSlice";

const emptyArray = [];

function useFunctionIds() {
  const root = useSelector(getRoot);
  const functions = nodeUtils.getFunctions(root);

  if (!functions) {
    return emptyArray;
  }

  return functions.map((e) => e.id);
}

export default useFunctionIds;
